<template>
  <v-container
    v-if='loaded'
    fill-height
    fluid
    grid-list-xl>
    
    <v-layout wrap>
    
      <v-flex
        v-if="$can('read','shipment')"
        sm6
        xs6
        md6
        lg6>
        <material-stats-card
          color="primary"
          icon="mdi-truck"
          title="Shipment"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.shipment)"
          :sub-text="`Shipment list`"
          to="/shipments"
        />
      </v-flex>


      <v-flex
            sm6
            xs6
            md6
            lg6>
        <material-stats-card
          color="primary"
          icon="mdi-file-pdf-box"
          title="PDF"
          sub-icon="mdi-download"
          :value="'Manual'"
          :sub-text="`Download Manual`"
          :href=" '/EMN_LOGISTIC_guide_v3.1_230323.pdf'"
          target="_blank"
        />
    </v-flex>


      <v-flex md12>
        <core-table v-if="$can('read','shipment')" :filters="{status1:{status:['Created', 'Confirmed', 'Shipped', 'Delivered']}}" hide-upsert :config="config_delivered"  @update="editShipment" title="Shipments" subtitle="'Created', 'Confirmed', 'Shipped', 'Delivered'" />
      </v-flex>

      <v-flex md12  v-if="$can('read','log')">
        <core-table hide-upsert :config="config_log" title="Audit Trail" />
      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import { getDashboardData } from '@/api/log'

import config_delivered from '@/views/shipment/config_delivered'
import config_log from '@/views/config_log'

export default {
  data () {
    return {
      config_delivered,
      config_log,
      dashboardData: {
        protocol:'',
        site:'',
        accouhnt:'',
        meddra_version:''
      },
      loaded: false,
    }
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_API
    }
  },
  async mounted () {
    this.getDashboardData()
  },
  methods: {
    getDashboardData () {
      getDashboardData().then(data => {
        this.dashboardData = data
        this.loaded = true
      })
    },
     editShipment(shipment) {
      this.$router.push(`/shipment/${shipment.id}`)
    },
    downloadManual() {
      
    }
  }
}
</script>

<style lang="scss">

.dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>
